<template>
  <div v-show="false"></div>
</template>

<script>
export default {
  name: 'CustomCSS',

  props: {
    customCss: {
      type: String,
      default: ''
    }
  },

  watch: {
    customCss: {
      immediate: true,
      handler(css) {
        this.applyCss(css)
      }
    }
  },

  beforeDestroy() {
    if (this.styleElement) {
      this.styleElement.remove()
      this.styleElement = null
    }
  },

  methods: {
    applyCss(css) {
      if (!this.styleElement) {
        this.styleElement = document.createElement('style')
        this.styleElement.setAttribute('data-source', 'place-context-custom-css')
        document.head.appendChild(this.styleElement)
      }
      this.styleElement.textContent = css || ''
    }
  }
}
</script>
